import { locationIdFormat } from "@redotech/redo-inventory-id";
import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import * as z from "zod";

export const getProductInventoryLevels = {
  name: "getProductInventoryLevels" as const,
  input: z.object({ productIds: z.array(productIdFormat.schema).max(500) }),
  output: z.object({
    items: z.array(
      z.object({
        productId: productIdFormat.schema,
        productFamilyId: productFamilyIdFormat.schema,
        locationId: locationIdFormat.schema.nullable(),
        locationName: z.string().nullable(),
        quantity: z.bigint().nullable(),
        committed: z.bigint().nullable(),
        available: z.bigint().nullable(),
        reserved: z.bigint().nullable(),
        reservedBuckets: z
          .array(
            z.object({
              bucketKey: z.string(),
              kind: z.string().nullable(),
              customTypeId: z.string().nullable(),
              quantity: z.bigint(),
            }),
          )
          .nullable(),
      }),
    ),
  }),
};
